import React from "react";
import classes from "../styles/style.module.css";
import AwardImg from "../../../assets/images/Roshana/awardImage.png";
import RoshanaButton from "../Button";
// import BookImg from "../../../assets/images/Roshana/Book.png";

const Awards = () => {
  return (
    <div className={classes.awardContainer}>
      <img src={AwardImg} alt="awardImage" className={classes.awardBox} />
      {/* <RoshanaButton
        color={"secondary"}
        text={"ورود"}
        handleClick={() => window.open("https://uism.ir/", "_blank").focus()}
        styles={{ width: "50%", marginTop: "30px" }}
      /> */}

      <RoshanaButton
        color={"secondary"}
        text={"کانال اطلاع رسانی"}
        handleClick={() =>
          window
            .open("https://eitaa.com/joinchat/3971416896C2a7b4c4afc", "_blank")
            .focus()
        }
        styles={{ width: "50%", marginTop: "30px" }}
      />
    </div>
  );
};

export default Awards;
